/**
 * Short list-column label for a message date.
 *
 * Boundaries are calendar days, not elapsed hours. Measuring elapsed time means a
 * message sent yesterday at 10:45 PM is only ~15 hours old by early afternoon, so it
 * would render as a bare "10:45 PM" and read as though it arrived today. Older
 * messages always carry a year so a 2025 mail can never be mistaken for a recent one.
 */
export const formatEmailListDate = (
  value: string | number | Date | null | undefined,
  now: Date = new Date()
): string => {
  if (!value) return '';

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const daysApart = Math.round((startOfDay(now) - startOfDay(date)) / 86_400_000);

  if (daysApart === 0) {
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  }

  if (daysApart === 1) return 'Yesterday';

  // Future dates (sender clock skew) fall through to the dated format on purpose
  if (daysApart > 1 && date.getFullYear() === now.getFullYear()) {
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};
